import React, { useState } from "react";
import { Box, List, ListItemButton, ListItemText, Divider, Collapse } from "@mui/material";
import { HiNewspaper } from "react-icons/hi";
import { HiViewBoards } from "react-icons/hi";
import { SiPivotaltracker } from "react-icons/si";
import { RiFileListFill } from "react-icons/ri";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { IoChevronDown, IoChevronUp } from "react-icons/io5";
import { MdSettingsSuggest } from "react-icons/md";
import { AiFillSchedule } from "react-icons/ai";
import { FaRupeeSign } from "react-icons/fa";
import { useCheckMenuPermission } from "hooks/useCheckMenuPermission";
import { ACTION_TRACKER_ACCESS, ACTION_TRACKER_DATA_ACCESS, BASELINE_SCHEDULE_ACCESS, CHANGE_ACCESS, CLAIM_ACCESS, COMPLIANCE_ACCESS, COMPLIANCE_DATA_ACCESS, CONTRACT_MANAGEMENT_ACCESS, COST_MANAGEMENT_ACCESS, COST_TRACKER_ACCESS, COST_UPDATE_ACCESS, DMS_ACCESS, ENGINEERING_ACCESS, ENGINEERING_DASHBOARD_ACCESS, IMPLEMENTATION_SCHEDULE_ACCESS, MACHINERY_ACCESS, MANPOWER_ACCESS, MASTER_DATA_ACCESS, MASTER_DEVELOPMENT_SCHEDULE_ACCESS, MATERIAL_ACCESS, MILESTONE_ACCESS, MONTHLY_PLAN_ACCESS, NCR_LOG_ACCESS, PHYSICAL_PROGRESS_ACCESS, PROCUREMENT_ACCESS, PROCUREMENT_DASHBOARD_ACCESS, REBASELINE_SCHEDULE_ACCESS, RECOVERY_SCHEDULE_ACCESS, RISK_ACCESS, RISK_DASHBOARD_ACCESS, RISK_DATA_ACCESS, SCHEDULE_DASHBOARD_ACCESS, STATUTORY_APPROVAL_ACCESS, UPDATE_SCHEDULE_ACCESS, WORKFLOW_ACCESS, WORKFLOW_DATA_ACCESS, HSE_ACCESS, CAPEX_ACCESS, HSE_DASHBOARD_ACCESS, VIEW_SCHEDULE_ACCESS, INCIDENT_ACCESS, EHS_FINDING_TRACKER_ACCESS, LEGAL_TRACKER_ACCESS, INVOICE_TRACKER_ACCESS, LEASE_DASHBOARD_ACCESS, DEALS_TRACKER_ACCESS, LEADS_TRACKER_ACCESS, INITIATE_WORKFLOW_ACCESS, DESIGN_ENGINEERING_DATA_ACCESS, EHS_FINDING_DATA_ACCESS, HSE_DATA_ACCESS, LEADS_DATA_ACCESS, LEGAL_COMPLIANCE_DATA_ACCESS, OPERATING_COST_DATA_ACCESS, PROCUREMENT_DATA_ACCESS, STATUTORY_APPROVAL_DATA_ACCESS, WAREHOUSING_DATA_ACCESS, RAIL_DATA_ACCESS, COMMERCIAL_DATA_ACCESS, INSURANCE_DATA_ACCESS, PROJECT_SETTING, CUSTOMER_DEPENDENCIES_ACCESS,ERP_DATA_ACCESS, FINANCIAL_BG_ACCESS } from "helpers/permissionConfig";
import { LuWorkflow } from "react-icons/lu";
import { IoDocuments } from "react-icons/io5";

import { MdLeaderboard } from "react-icons/md";
import { enterpriseTokens } from "styles/theme";

const LeftSideBar = ({ onHamburgerToggle, isOpen, customerRole }) => {

  const { hasPermission, hasRoleCheck } = useCheckMenuPermission();

  const { projectId } = useParams();
  const navigate = useNavigate();
  const location = useLocation();

  const [selected, setSelected] = useState("Overview");
  const [openMobile, setOpenMobile] = useState(false);
  const [openMenus, setOpenMenus] = useState({});

  const listItemTextStyle = (isActive) => ({
    fontWeight: isActive ? 700 : 500,
    fontSize: "12px",
    lineHeight: "18px",
    letterSpacing: "0px",
    color: isActive ? enterpriseTokens.primary : enterpriseTokens.slate,
    fontFamily: "Inter, Outfit, sans-serif",
  });

  const menuItems = [
    // { key: "Dashboard", icon: HiNewspaper, path: "", },
    {
      key: "Overview", icon: HiNewspaper,
      hasSubmenu: false,
      path: "",
      permissionKey: [COST_MANAGEMENT_ACCESS, SCHEDULE_DASHBOARD_ACCESS, ENGINEERING_DASHBOARD_ACCESS, RISK_DASHBOARD_ACCESS, PROCUREMENT_DASHBOARD_ACCESS, CONTRACT_MANAGEMENT_ACCESS, HSE_DASHBOARD_ACCESS, LEASE_DASHBOARD_ACCESS],
    },
    // { key: "My work", icon: HiNewspaper, path: "my-work-dashboard", },

    {
      key: "Action Tracker", icon: HiNewspaper, path: "action-tracker",
      permissionKey: [ACTION_TRACKER_ACCESS],
    },

    // { key: "Safety", icon: HiNewspaper, path: "safety", },
    //{ key: "Issue", icon: HiNewspaper, path: "issue-list", },
    // { key: "Baseline Schedule", icon: HiNewspaper, path: "schedule", },

    {
      key: "Schedule Management", icon: AiFillSchedule,
      hasSubmenu: true,
      permissionKey: [VIEW_SCHEDULE_ACCESS, CAPEX_ACCESS, MILESTONE_ACCESS],
      submenus: [
        { key: "Schedule Overview", path: "schedule-view" },
        { key: "Capex", path: "capex" },
        { key: "Milestones", path: "milestone" },
      ],
    },
    // {
    //   key: "DPR", icon: RiFileListFill,
    //   hasSubmenu: true,
    //   permissionKey: [PHYSICAL_PROGRESS_ACCESS, MONTHLY_PLAN_ACCESS, MATERIAL_ACCESS, MANPOWER_ACCESS, MACHINERY_ACCESS],
    //   submenus: [
    //     { key: "Physical Progress", path: "dpr/physical-progress" },
    //     { key: "Monthly Plan", path: "dpr/monthly-plan" },
    //     // { key: "Milestone", path: "dpr/milestone" },
    //     { key: "Material", path: "" },
    //     { key: "Manpower", path: "" },
    //     { key: "Machinery", path: "" },
    //   ],
    // },
    {
      key: "Admin & Setup", icon: MdSettingsSuggest,
      hasSubmenu: true,
      permissionKey: [WORKFLOW_ACCESS, CUSTOMER_DEPENDENCIES_ACCESS, PROJECT_SETTING, MASTER_DATA_ACCESS],
      submenus: [
        { key: "Workflow Rules", path: "settings/workflow" },
        { key: "Customer Dependencies", path: "settings/customer-dependencies" },
        { key: "Project Settings", path: "settings/project-settings" },
        {
          key: "Master Data",
          hasSubmenu: true,
          permissionKey: [ACTION_TRACKER_DATA_ACCESS, COMPLIANCE_DATA_ACCESS, DESIGN_ENGINEERING_DATA_ACCESS, EHS_FINDING_DATA_ACCESS, HSE_DATA_ACCESS, LEADS_DATA_ACCESS, LEGAL_COMPLIANCE_DATA_ACCESS, OPERATING_COST_DATA_ACCESS, PROCUREMENT_DATA_ACCESS, RISK_DATA_ACCESS, STATUTORY_APPROVAL_DATA_ACCESS, WORKFLOW_DATA_ACCESS, WAREHOUSING_DATA_ACCESS, RAIL_DATA_ACCESS, COMMERCIAL_DATA_ACCESS, INSURANCE_DATA_ACCESS],
          submenus: [
            { key: "Action Tracker Data", path: "settings/masterdata/action-tracker" },
            { key: "Claims Data", path: "settings/masterdata/claim" },
            { key: "Change Orders Data", path: "settings/masterdata/change" },
            { key: "Compliance Data", path: "settings/masterdata/compliance" },
            { key: "Design & Engineering Data", path: "settings/masterdata/design-engineering" },
            { key: "EHS Finding Data", path: "settings/masterdata/ehs-finding" },
            { key: "Financial BG Data", path: "settings/masterdata/financial-bg" },
            { key: "HSE Data", path: "settings/masterdata/hse" },
            { key: "Invoice / ERP Data", path: "settings/masterdata/invoice" },
            { key: "Leads Data", path: "settings/masterdata/leads" },
            { key: "Legal Compliance Data", path: "settings/masterdata/legal-compliance" },
            { key: "NCR Log Data", path: "settings/masterdata/ncr-log" },
            { key: "Operating Cost Data", path: "settings/masterdata/operating-cost" },
            { key: "Procurement Data", path: "settings/masterdata/procurement" },
            { key: "Risk Data", path: "settings/masterdata/risk" },
            { key: "Statutory Approval Data", path: "settings/masterdata/statutory-approval" },
            { key: "Workflow Data", path: "settings/masterdata/workflow" },
            { key: "Warehousing / Leasing", path: "settings/masterdata/warehousing" },
            { key: "Rail / Leasing", path: "settings/masterdata/rail" },
            { key: "Commercial / Leasing", path: "settings/masterdata/commercial" },
            { key: "Insurance", path: "settings/masterdata/insurance" },
            // { key: "Legal Compliance Data", path:"settings/masterdata/legal-compliance"},
          ],
        },
      ],
    },
    // { key: "Risk", icon: HiViewBoards },
    {
      key: "Trackers", icon: HiViewBoards,
      hasSubmenu: true,
      permissionKey: [RISK_ACCESS, COMPLIANCE_ACCESS, ENGINEERING_ACCESS, STATUTORY_APPROVAL_ACCESS, NCR_LOG_ACCESS, PROCUREMENT_ACCESS, CLAIM_ACCESS, CHANGE_ACCESS, INVOICE_TRACKER_ACCESS, FINANCIAL_BG_ACCESS],
      submenus: [
        { key: "Risk", path: "risk" },
        { key: "Compliance", path: "compliance-tracker" },
        { key: "Design & Engineering", icon: SiPivotaltracker, path: "engineering-tracker", },
        { key: "Statutory Approvals", icon: SiPivotaltracker, path: "approval-tracker", },
        { key: "NCR Log", path: "ncr-log-tracker" },
        { key: "Procurement", path: "procurement" },
        { key: "Claims", path: "claim-tracker" },
        // { key: "Cost Tracker", path: "cost-tracker" },
        { key: "Change Orders", path: "change-tracker" },
        {
          key: "Invoice",
          hasSubmenu: true,
          permissionKey: [INVOICE_TRACKER_ACCESS, ERP_DATA_ACCESS],
          submenus: [
            { key: "Invoice Tracker", path: "invoice-tracker" },
            { key: "ERP Data", path: "erp-data", },
          ]
        },
        // { key: "Invoice", path: "invoice-tracker" },
        { key: "Financial BG", path: "financial-bg-tracker" },
      ],
    },
    {
      key: "HSE",
      icon: HiNewspaper,
      hasSubmenu: "true", permissionKey: [HSE_ACCESS, INCIDENT_ACCESS, EHS_FINDING_TRACKER_ACCESS, LEGAL_TRACKER_ACCESS],
      submenus: [
        { key: "HSE Tracker", path: "hse-tracker" },
        { key: "Incident Tracker", path: "incident-tracker" },
        { key: "EHS Findings", path: "ehs-finding-tracker" },
        { key: "Legal Compliance", path: "legal-tracker" },
      ]
    },

    { key: "Document Management", icon: IoDocuments, path: "dms", permissionKey: [DMS_ACCESS] },
    {
      key: "Cost", icon: FaRupeeSign,
      hasSubmenu: true,
      permissionKey: [COST_TRACKER_ACCESS, COST_UPDATE_ACCESS],
      submenus: [
        { key: "Cost Tracker", path: "cost-tracker" },
        { key: "Cost Update", path: "cost-tracker-update" },
      ],
    },
    {
      key: "Workflows", icon: LuWorkflow, path: "initiate-workflow",
      permissionKey: [INITIATE_WORKFLOW_ACCESS],
    },
    {
      key: "Lease", icon: MdLeaderboard,
      hasSubmenu: true,
      permissionKey: [LEADS_TRACKER_ACCESS, DEALS_TRACKER_ACCESS],
      submenus: [
        { key: "Leads", path: "leads-tracker" },
        { key: "Deals", path: "deals-tracker" },
      ],
    },

    // {
    //   key: "Procurement", icon: HiViewBoards,
    //   hasSubmenu: true,
    //   submenus: [
    //     { key: "SITC", path: "procurement-sitc" },
    //     { key: "DP Items", path: "procurement-dp-items" },
    //   ],
    // },
    // {
    //   key: "Procurement", icon: HiViewBoards,
    //   hasSubmenu: true,
    //   submenus: [
    //     { key: "SITC", path: "procurement-sitc" },
    //     { key: "DP Items", path: "procurement-dp-items" },
    //   ],
    // },
    // { key: "Issues", icon: LuTrendingUp },
    // { key: "Document Management", icon: HiCollection, divider: true },
    // { key: "Menu 2", icon: RiFileListFill },
    // { key: "Menu 3", icon: RiFileListFill },
    // { key: "Menu 4", icon: RiFileListFill },
    // { key: "Menu 5", icon: RiFileListFill },
  ];

  const handleSubmenuClick = (submenu) => {
    setSelected(submenu.key);
    navigate(submenu.path);
  };

  const handleToggleMenu = (menuKey) => {
    setOpenMenus((prev) => ({
      ...prev,
      [menuKey]: !prev[menuKey],
    }));
  };

  const handleMenuClick = (item) => {
    if (item.hasSubmenu) {
      handleToggleMenu(item.key);
      setSelected(item.key);
    } else {
      setSelected(item.key);
      navigate(`/projects/${projectId}/${item.path}`);
    }
  };

  return (
    <Box
      sx={{
        // width: { xs: openMobile ? 200 : 50, sm: 220 },
        width: { xs: openMobile ? 200 : 50, sm: isOpen ? 220 : 0 },
        bgcolor: "#FFFFFF",
        borderRight: `1px solid ${enterpriseTokens.lineSoft}`,
        p: isOpen ? 0.75 : 0,
        transition: "width 0.3s ease",
        overflowX: "hidden",
        position: "relative",
        boxShadow: "none",
      }}
    >

      {/* Hamburger Icon only on mobile */}
      {/* <IconButton
        onClick={() => {
          const newState = !openMobile;
          setOpenMobile(newState);

          if (typeof onHamburgerToggle === "function") {
            onHamburgerToggle(newState);
          }
        }}
        sx={{
          display: { xs: "flex", sm: "none" },
          position: "absolute",
          top: 10,
          left: 14,
          zIndex: 2,
        }}
      >
        {openMobile ? (
          <ImMenu4 size={30} color="#A7B4BD" />
        ) : (
          <ImMenu3 size={30} color="#A7B4BD" />
        )}

      </IconButton> */}

      <List
        sx={{
          display: {
            xs: openMobile ? "block" : "none",
            sm: "block",
          },
          transition: "all 0.3s ease",
          "& .MuiListItemButton-root": {
            py: 0.35,
            //minHeight: 32,
          },
        }}
      >
        {menuItems?.filter(item => hasPermission(item?.permissionKey) > 0 || !item?.permissionKey || hasRoleCheck() > 0)?.map((item, index) => {
          const mainActiveMenu = (() => {
            if (item.route === "") {
              return location.pathname === `/projects/${projectId}`;
            } else {
              if (item.route && item.route !== false) {
                return location.pathname.endsWith(
                  `/projects/${projectId} / ${item.route}`
                );
              }
              return false;
            }
          })();
          return (
            <React.Fragment key={item.key}>
              {item.divider && <Divider sx={{ my: 1 }} />}
              <ListItemButton
                selected={selected === item.key}
                onClick={() => handleMenuClick(item)}
                sx={{
                  backgroundColor: selected === item.key ? "#EAF2FF" : "transparent",
                  border: `1px solid ${selected === item.key ? "#BFDBFE" : "transparent"}`,
                  borderRadius: "3px",
                  mx: 0.25,
                  px: 1,
                  color: enterpriseTokens.slate,
                  "&:hover": { backgroundColor: selected === item.key ? "#EAF2FF" : "#F4F7FB" },
                }}
              >
                <item.icon
                  size={18}
                  style={{
                    marginRight: 10,
                    color: selected === item.key ? enterpriseTokens.primary : enterpriseTokens.muted,
                  }}
                />
                <ListItemText
                  primary={item.key}
                  primaryTypographyProps={listItemTextStyle(selected === item.key)}
                />

                {item.hasSubmenu &&
                  (openMenus[item.key] ? (
                    <IoChevronUp size={15} color={enterpriseTokens.muted} />
                  ) : (
                    <IoChevronDown size={15} color={enterpriseTokens.muted} />
                  ))}

              </ListItemButton>
              {item.hasSubmenu && (
                <Collapse in={openMenus[item.key]} timeout="auto" unmountOnExit>
                  {item?.submenus?.filter((sub, ind) => hasPermission([item?.permissionKey?.[ind]]) > 0 || !item?.permissionKey || hasRoleCheck() > 0)?.map((submenu) => (
                    <React.Fragment key={submenu.key}>

                      {/* LEVEL 1 SUBMENU (Workflow + Master Data Plan) */}
                      <ListItemButton
                        onClick={() =>
                          submenu.hasSubmenu
                            ? handleToggleMenu(submenu.key)
                            : handleSubmenuClick(submenu)
                        }
                        sx={{
                          pl: 4.5,
                          mx: 0.3,
                          borderRadius: "3px",
                          backgroundColor:
                            selected === submenu.key ? "#EAF2FF" : "transparent",
                          "&:hover": { backgroundColor: "#F4F7FB" },
                        }}
                      >
                        <ListItemText
                          primary={submenu.key}
                          primaryTypographyProps={listItemTextStyle(
                            selected === submenu.key
                          )}
                        />

                        {/* Nested submenu arrow */}
                        {submenu.hasSubmenu &&
                          (openMenus[submenu.key] ? (
                            <IoChevronUp size={15} color={enterpriseTokens.muted} />
                          ) : (
                            <IoChevronDown size={15} color={enterpriseTokens.muted} />
                          ))}
                      </ListItemButton>

                      {/* LEVEL 2 NESTED SUBMENU (Activity/Resource/Unit Master) */}
                      {submenu.hasSubmenu && (
                        <Collapse in={openMenus[submenu.key]} timeout="auto" unmountOnExit>
                          {submenu.submenus?.filter((sub, inds) => hasPermission([submenu?.permissionKey?.[inds]]) > 0 || !submenu?.permissionKey || hasRoleCheck() > 0)?.map((child) => (
                            <ListItemButton
                              key={child.key}
                              onClick={() => handleSubmenuClick(child)}
                              sx={{
                                pl: 7,
                                mx: 0.8,
                                borderRadius: "3px",
                                backgroundColor:
                                  selected === child.key ? "#EAF2FF" : "transparent",
                                "&:hover": { backgroundColor: "#F4F7FB" },
                              }}
                            >
                              <ListItemText primary={child.key} primaryTypographyProps={listItemTextStyle(
                                selected === child.key
                              )} />
                            </ListItemButton>
                          ))}
                        </Collapse>
                      )}
                    </React.Fragment>
                  ))}
                </Collapse>
              )}
            </React.Fragment>
          );
        }
        )}
      </List>
    </Box>
  );
};

export default LeftSideBar;
